export default {
  name: 'document',
  components: {},
  props: [],
  data () {
    return {
      img_word: '/static/img/doc.png',
      img_pdf: '/static/img/pdf.png',
      libraries_doc: {},
      errors: {},
      grid: true
    }
  },
  computed: {
    data() {
      return this.$store.getters['Library/getLibraryDoc']
    }
  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Library/getLibrariesDoc', {})
    ]).then(res =>{
      this.$loading.complete()
    }).catch(errors => {
      console.log(errors)
      this.$loading.fail()
    })
  },
  methods: {
    showGrid(){
      this.grid = true;
    },
    showList(){
      this.grid = false;
    },
    viewDoc(item){
      return 'https://docs.google.com/viewerng/viewer?url=' +this.data.url + item
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/library/document/document.js